var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
var SceptreModel;
(function (SceptreModel) {
    SceptreModel["U550CV"] = "-MChiisouHpeKqLWC0aj";
    SceptreModel["IrGroup1"] = "-MChimKI260TDNdRMxUL";
    SceptreModel["IrGroup2"] = "-MChipAlkIQi0_K_gTee";
})(SceptreModel || (SceptreModel = {}));
export class SceptreIr {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.irConnector = '1';
        this.model = '';
        this.irCodes = {
            '-MChiisouHpeKqLWC0aj': {
                //U550CV
                hdmi1: 
                // from sony DRC cinemotion - seems to select next HDMI source...
                ',1,40000,3,1,96,24,48,24,24,24,24,24,48,24,48,24,48,24,24,24,24,24,24,24,48,24,24,24,24,24,48,24,24,24,48,816',
                // hdmi 2 works based on sceptre csv from global cache ir database
                hdmi2: ',1,40000,3,1,96,24,48,24,24,24,24,24,48,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,1028',
                // hdmi input 3 = sony pc input
                hdmi3: 
                // also noticed sony Input Analog RGB 1 PC selects HDMI 3 on the sceptre
                ',1,40000,3,1,96,25,49,25,49,25,25,25,25,25,25,25,25,25,49,25,49,25,25,25,25,25,25,25,25,1013',
                hdmi4: ',1,38226,3,1,96,24,48,24,48,24,24,24,48,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,1004,96,24,48,24,48,24,24,24,48,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,1004',
                ypbpr: 
                // sony INPUT DIGITAL RGB 1
                ',1,40000,3,1,96,24,48,24,24,24,48,24,24,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,1128',
                av: ',1,38226,3,1,96,23,47,23,47,23,47,23,23,23,47,23,23,23,23,23,47,23,23,23,23,23,23,23,23,1012,96,23,47,23,47,23,47,23,23,23,47,23,23,23,23,23,47,23,23,23,23,23,23,23,23,1012',
                // video input 1 on sony tv = input tv
                tv: ',1,38000,3,1,92,22,22,22,22,22,22,22,22,22,22,22,22,22,46,22,46,22,22,22,22,22,22,22,22,1027',
                powerOff: 
                // from IR learner
                ',2,38226,3,1,91,23,46,22,23,22,46,22,23,22,46,22,23,22,23,22,46,22,23,22,23,22,23,22,23,986,91,23,46,22,23,22,46,22,23,22,46,22,23,22,23,22,46,22,23,22,23,22,23,22,23,986',
                powerOn: 
                // set to same as power off since there is just a power toggle
                ',2,38226,3,1,91,23,46,22,23,22,46,22,23,22,46,22,23,22,23,22,46,22,23,22,23,22,23,22,23,986,91,23,46,22,23,22,46,22,23,22,46,22,23,22,23,22,46,22,23,22,23,22,23,22,23,986',
            },
            '-MChimKI260TDNdRMxUL': {
                // irCodesGroup1: from Global Cache IR Tower database
                av: ',1,38000,3,1,341,170,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,21,21,64,21,21,21,21,21,21,21,21,21,21,21,21,21,64,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,64,21,21,21,21,21,1719',
                component1: ',1,38000,3,1,341,170,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,21,21,64,21,21,21,21,21,21,21,64,21,21,21,64,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,21,21,64,21,64,21,64,21,21,21,1719',
                component2: ',1,38000,3,1,341,170,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,21,21,64,21,21,21,21,21,64,21,64,21,21,21,64,21,21,21,21,21,64,21,64,21,21,21,21,21,64,21,21,21,64,21,64,21,21,21,21,21,1719',
                dvi: ',1,38000,3,1,342,171,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,21,21,64,21,21,21,21,21,21,21,64,21,64,21,64,21,64,21,21,21,21,21,64,21,64,21,21,21,21,21,21,21,21,21,64,21,64,21,21,21,1724',
                svideo: ',1,38000,3,1,341,170,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,21,21,64,21,21,21,21,21,64,21,64,21,64,21,64,21,21,21,21,21,64,21,64,21,21,21,21,21,21,21,21,21,64,21,64,21,21,21,21,21,1719',
                scartd4: ',1,38000,3,1,341,170,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,21,21,64,21,21,21,21,21,64,21,21,21,21,21,64,21,21,21,21,21,21,21,64,21,21,21,64,21,64,21,21,21,64,21,64,21,64,21,21,21,1719',
                tv: ',1,38000,3,1,342,171,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,21,21,64,21,21,21,21,21,21,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,64,21,21,21,1724',
                vga: ',1,38000,3,1,341,170,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,21,21,64,21,21,21,21,21,64,21,21,21,64,21,21,21,21,21,21,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,64,21,64,21,21,21,1719',
                powerOff: ',1,38000,3,1,341,170,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,21,21,64,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,21,21,1719',
                powerOn: ',1,38000,3,1,341,170,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,21,21,64,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,21,21,1719',
            },
            '-MChipAlkIQi0_K_gTee': {
                // irCodesGroup2 from Global Cache IR Tower database
                hdmi1: ',1,40000,3,1,96,24,24,24,24,24,24,24,48,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,1052',
                hdmi2: ',1,40000,3,1,96,24,48,24,24,24,24,24,48,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,1028',
                hdmi3: ',1,40000,3,1,96,24,24,24,48,24,24,24,48,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,1028',
                hdmi4: ',1,40000,3,1,96,24,48,24,48,24,24,24,48,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,1004',
                av: ',1,41000,3,1,96,23,47,23,47,23,47,23,23,23,47,23,23,23,23,23,47,23,23,23,23,23,23,23,23,1012',
                mhl: ',1,40000,3,1,96,23,23,23,47,23,23,23,47,23,23,23,23,23,47,23,47,23,23,23,23,23,23,23,23,979',
                pc: ',1,41000,3,1,96,23,23,23,47,23,47,23,23,23,47,23,47,23,23,23,47,23,23,23,23,23,23,23,23,1012',
                tv: ',1,38000,3,1,92,22,22,22,22,22,22,22,22,22,22,22,22,22,46,22,46,22,22,22,22,22,22,22,22,1027',
                usb: ',1,40000,3,1,96,23,47,23,47,23,23,23,23,23,23,23,47,23,47,23,47,23,23,23,23,23,23,23,23,1020',
                powerOff: ',1,41000,3,1,96,23,47,23,23,23,47,23,23,23,47,23,23,23,23,23,47,23,23,23,23,23,23,23,23,1043',
                powerOn: ',1,41000,3,1,96,23,47,23,23,23,47,23,23,23,47,23,23,23,23,23,47,23,23,23,23,23,23,23,23,1043',
            },
        };
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: `ping`,
                next: /ERR(?:\s*|_)\d+/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.power = {
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                yield this.socket.send(this.buildCommand(`${power ? 'powerOn' : 'powerOff'}`), /completeir,\d:\d|busyIR/i, tags);
                // power toggle-only devices don't need a confirmation for power off
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 4000);
                return power;
            }),
            isToggle: true,
        };
        this.videoInput = {
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                yield this.socket.send(this.buildCommand(`${code}`), /completeir,\d:\d|busyIR/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                return code;
            }),
        };
        // polling
        this.polls = [
            {
                intervalMs: 4000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    if (this.socket.hasCommands())
                        return;
                    yield this.socket.send('ping', /ERR(?:\s*|_)\d+/i, ['poll']);
                }),
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.irConnector = (_b = (_a = config.ir) === null || _a === void 0 ? void 0 : _a.connector) !== null && _b !== void 0 ? _b : '1';
            if (config.modelNumber === SceptreModel.U550CV) {
                this.model = SceptreModel.U550CV;
            }
            else if (config.modelNumber === SceptreModel.IrGroup1) {
                this.model = SceptreModel.IrGroup1;
            }
            else if (config.modelNumber === SceptreModel.IrGroup2) {
                this.model = SceptreModel.IrGroup2;
            }
            else {
                this.model = SceptreModel.U550CV; // default for testing
            }
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
    // other class methods
    buildCommand(name) {
        return `sendir,1:${this.irConnector}${this.irCodes[this.model][name]}`;
    }
}
// static properties
SceptreIr.driverType = 'socketDriver';
SceptreIr.key = '-MChhZC8LucXUbBtkgAH';
SceptreIr.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r'],
    },
    sendTerminator: '\r',
};
SceptreIr.socketOptions = [
    Object.assign(Object.assign({}, SceptreIr.baseSocketOptions), { port: 4998 }),
];
